module.exports = __webpack_public_path__ + "img/symbol_9.30140e0a.png";